import { IntervalDataEntry, IntervalDisplayParam } from '@/hooks'

/**
 * Extracts the appropriate ID from an IntervalDataEntry based on the display setting.
 *
 * @param entry - The interval data entry containing meterId and/or subMeterId
 * @param display - The display setting ('meters' or 'subMeters')
 * @returns The subMeterId when display is 'subMeters', otherwise meterId
 */
export const getEntryId = (
    entry: IntervalDataEntry,
    display: IntervalDisplayParam
): number | undefined => {
    return display === 'subMeters' ? entry.subMeterId : entry.meterId
}
